export default __webpack_public_path__ + "static/media/Нэгдсэн_уулзалт_гүйцэтгэл,_үнэлгээний_журам,_тогтолцоо,_нэмэгдэл.ab08de60.pdf";